<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class=" rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">table_content_section</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-12 p-2 pb-0">
                <p class="label_css">heading</p>
                <textarea v-model="fieldJsonData.heading"
                :class="heading_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                ></textarea>
                <p v-if="heading_err" class="text-error heading-6">heading is required</p>
              </div>
               <div v-if="descriptionEditor === false" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <p class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openDescription()">{{componentDetailsForEdit !== null ? "+ Edit Description" : "+ Add Description"}}</p>
                <p v-if="componentDetailsForEdit !== null" v-html="fieldJsonData.description"></p>
                <p v-if="desc_err" class="text-error heading-6">description is required</p>
              </div>
              <div v-if="descriptionEditor" class="box col-span-12 p-2 pb-0" v-click-outside="closeDescription">
                <p class="label_css">description</p>
                <editor v-model="fieldJsonData.description"
                :class="desc_err ? 'border border-error' : ''" 
                placeholder="description"
                ></editor>
                <p v-if="desc_err" class="text-error heading-6">description is required</p>
              </div>
            </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">tab_list</p>
           <div v-for="(data, index) in fieldJsonData.tab_list" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">tab_name</p>
                    <input v-model="data.tab_name"
                    :class="data.tab_name_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="tab_name"
                    >
                    <p v-if="data.tab_name_err" class="text-error heading-6">tab_name is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">tab_slug</p>
                    <textarea v-model="data.tab_slug"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="tab_slug"
                    ></textarea>
                </div> -->
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">com_slug</p>
                    <input v-model="data.com_slug"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="com_slug"
                    >
                </div> -->
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">content_heading</p>
                    <textarea v-model="data.content_heading"
                    :class="data.content_heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="data.content_heading_err" class="text-error heading-6">content_heading is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading_style</p>
                    <input v-model="data.heading_style"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading_style"
                    >
                </div> -->
                <div v-if="tempCardDescriptionIndex !== index" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <label class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openContentDescription(index)">{{componentDetailsForEdit !== null ? "+ Edit Description" : "+ Add Description"}}</label>
                <p v-if="componentDetailsForEdit !== null" v-html="data.content_description"></p>
                <p v-if="data.content_description_err" class="text-error heading-6">content_description is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex === index && cardDescriptionEditor === false" class="box col-span-12 p-2 pb-0">
                    <p class="label_css">content_description</p>
                    <editor v-model="data.content_description"
                    :class="data.content_description_err ? 'border border-error' : ''" 
                    placeholder="content_description"
                    ></editor>
                    <p v-if="data.content_description_err" class="text-error heading-6">content_description is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_url</p>
                    <input v-model="data.img_url"
                    :class="data.img_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_url"
                    >
                    <p v-if="data.img_url_err" class="text-error heading-6">img_url is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_alt</p>
                    <input v-model="data.img_alt"
                    :class="data.img_alt_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_alt"
                    >
                    <p v-if="data.img_alt_err" class="text-error heading-6">img_alt is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">cta_text</p>
                    <input v-model="data.cta_text"
                    :class="data.cta_text_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="cta_text"
                    >
                    <p v-if="data.cta_text_err" class="text-error heading-6">cta_text is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">cta_url</p>
                    <input v-model="data.cta_url"
                    :class="data.cta_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="cta_url"
                    >
                    <p v-if="data.cta_url_err" class="text-error heading-6">cta_url is required</p>
                </div>
                <div class="col-span-6 mt-2 p-2 pb-0">
                    <p class="label_css">cta_in_new_tab</p>
                    <div class="flex items-center pb-1 ">
                    <input :id="`default-radio-3-${index}`" v-model="data.cta_in_new_tab" type="radio" :value="false" :name="`default-radio-3-${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-3-${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">No</label>
                    </div>
                    <div class="flex items-center pb-1 col-span-6">
                    <input :id="`default-radio-4-${index}`" v-model="data.cta_in_new_tab" type="radio" :value="true" :name="`default-radio-4-${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`default-radio-4-${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">Yes</label>
                    </div>
               </div>
               <div class="col-span-6 mt-2 p-2 pb-0">
                    <p class="label_css">is_visible</p>
                    <div class="flex items-center pb-1 ">
                    <input :id="`is_visible_No_${index}`" v-model="data.is_visible" type="radio" :value="false" :name="`is_visible_No_${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`is_visible_No_${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">No</label>
                    </div>
                    <div class="flex items-center pb-1 col-span-6">
                    <input :id="`is_visible_Yes_${index}`" v-model="data.is_visible" type="radio" :value="true" :name="`is_visible_Yes_${index}`" class="w-5 h-5 text-primary bg-gray-100 border-gray-300 outline-none cursor-pointer">
                    <label :for="`is_visible_Yes_${index}`" class="ml-2 heading-4 text-text2  dark:text-gray-300 cursor-pointer">Yes</label>
                    </div>
               </div>
               <div class="py-2 px-1 col-span-12  gap-x-2 mt-4" style="border: 1px solid #ccc">
            <p class="label_css pl-2 font-bold">icons_list</p>
           <div v-for="(iconData, iconIndex) in data.icons_list" :key="iconIndex" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">image_url</p>
                    <input v-model="iconData.image_url"
                    :class="iconData.image_url_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="image_url"
                    >
                    <p v-if="iconData.image_url_err" class="text-error heading-6">image_url is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">image_alt</p>
                    <input v-model="iconData.image_alt"
                    :class="iconData.image_alt_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="image_alt"
                    >
                    <p v-if="iconData.image_alt_err" class="text-error heading-6">image_alt is required</p>
                </div>
                 <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">img_group_slug</p>
                    <input v-model="iconData.img_group_slug"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="img_group_slug"
                    >
                </div> -->
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="iconIndex !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeIconDetails(iconIndex, index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="iconIndex === data.icons_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addIconDetails(index)"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="data.icons_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeTabDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.tab_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addTabDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.tab_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      desc_err: false,
      heading_err: false,
      isError: true,
      descriptionEditor: false,
      cardDescriptionEditor: false,
      tempCardDescriptionIndex: null,
      // fieldJsonData: {
      //   component_name: "fieldJsonData",
      //   heading: "",
      //   description: "",
      //   tab_list: [
      //       {
      //       heading: "",
      //       heading_err: false,
      //       description: ""
      //       },
      //       {
      //       heading: "",
      //       heading_err: false,
      //       description: ""
      //       },
      //       {
      //       heading: "",
      //       heading_err: false,
      //       description: ""
      //       },
      //       {
      //       heading: "",
      //       heading_err: false,
      //       description: ""
      //       }
      //   ],
      //   tab_detail_content: [
      //       {
      //       com_slug: "",
      //       com_slug_err: false,
      //       cta_in_new_tab: false,
      //       cta_text: "",
      //       cta_text_err: false,
      //       cta_url: "",
      //       cta_url_err: false,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       heading_style: null,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       is_visible: true
      //       },
      //       {
      //       com_slug: "",
      //       com_slug_err: false,
      //       cta_in_new_tab: false,
      //       cta_text: "",
      //       cta_text_err: false,
      //       cta_url: "",
      //       cta_url_err: false,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       heading_style: null,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       is_visible: true
      //       },
      //       {
      //       com_slug: "",
      //       com_slug_err: false,
      //       cta_in_new_tab: false,
      //       cta_text: "",
      //       cta_text_err: false,
      //       cta_url: "",
      //       cta_url_err: false,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       heading_style: null,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       is_visible: true
      //       },
      //       {
      //       com_slug: "",
      //       com_slug_err: false,
      //       cta_in_new_tab: false,
      //       cta_text: "",
      //       cta_text_err: false,
      //       cta_url: "",
      //       cta_url_err: false,
      //       description: "",
      //       description_err: false,
      //       heading: "",
      //       heading_err: false,
      //       heading_style: null,
      //       img_alt: "",
      //       img_alt_err: false,
      //       img_url: "",
      //       img_url_err: false,
      //       is_visible: true
      //       }
      //   ],
      //   icons_list: [
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       },
      //       {
      //       image_alt: "",
      //       image_alt_err: false,
      //       image_url: "",
      //       image_url_err: false,
      //       img_group_slug: "",
      //       img_group_slug_err: false
      //       }
      //   ]
      // }
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
    }
  },
  mounted () {
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.description !== '') {
          this.desc_err = false
          this.isError = false
        }
        if (this.fieldJsonData.heading !== '') {
          this.heading_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
          if (this.fieldJsonData.tab_list[index].tab_name !== '') {
            this.fieldJsonData.tab_list[index].tab_name_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[index].content_heading !== '') {
            this.fieldJsonData.tab_list[index].content_heading_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[index].content_description !== '') {
            this.fieldJsonData.tab_list[index].content_description_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[index].img_url !== '') {
            this.fieldJsonData.tab_list[index].img_url_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[index].img_alt !== '') {
            this.fieldJsonData.tab_list[index].img_alt_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[index].cta_text !== '') {
            this.fieldJsonData.tab_list[index].cta_text_err = false
            this.isError = false
          }
          if (this.fieldJsonData.tab_list[index].cta_url !== null) {
            this.fieldJsonData.tab_list[index].cta_url_err = false
            this.isError = false
          }
        }
      //   for (let indexM = 0; indexM < this.fieldJsonData.tab_list.length; indexM++) {
      //    for (let index = 0; index < this.fieldJsonData.tab_list[indexM].icons_list.length; index++) {
      //     if (this.fieldJsonData.tab_list[indexM].icons_list[index].image_url !== '') {
      //       this.fieldJsonData.tab_list[indexM].icons_list[index].image_url_err = false
      //       this.isError = false
      //     }
      //     if (this.fieldJsonData.tab_list[indexM].icons_list[index].image_alt !== '') {
      //       this.fieldJsonData.tab_list[indexM].icons_list[index].image_alt_err = false
      //       this.isError = false
      //     }
      //    }
      // }
      },
      deep: true
    }
  },
  methods: {
    openDescription () {
      this.descriptionEditor = true
    },
    closeDescription () {
      this.descriptionEditor = false
    },
    openContentDescription (index) {
      this.descriptionEditor = false
      this.tempCardDescriptionIndex = index
    },
    addTabDetails () {
      this.fieldJsonData.tab_list.push({
        com_slug: '',
        content_description: '',
        content_heading: '',
        cta_in_new_tab: false,
        cta_text: '',
        cta_url: null,
        heading_style: null,
        img_alt: '',
        img_url: '',
        is_visible: true,
        tab_name: '',
        tab_slug: null,
        icons_list: [{
          image_alt: "",
          image_url: "",
          img_group_slug: ""
        }]
      })
      console.log("addddddd", this.fieldJsonData.card_list);
    },
    removeTabDetails (index) {
      if (this.fieldJsonData.tab_list.length !== 1) {
        this.fieldJsonData.tab_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.tab_list);
    },
    addIconDetails (iconIndex) {
      for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
        if (iconIndex === index) {
          this.fieldJsonData.tab_list[index].icons_list.push({
            image_alt: "",
            image_alt_err: false,
            image_url: "",
            image_url_err: false,
            img_group_slug: "",
          })
        }
      }
      console.log("addddddd", this.fieldJsonData.tab_list);
    },
    removeIconDetails (iconIndex, tabIndex) {
      if (this.fieldJsonData.tab_list[tabIndex].icons_list.length !== 1) {
        this.fieldJsonData.tab_list[tabIndex].icons_list.splice(iconIndex, 1)
      }
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.description === '') {
        this.desc_err = true
        this.isError = true
      }
      if (this.fieldJsonData.heading === '') {
        this.heading_err = true
        this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
          if (this.fieldJsonData.tab_list[index].tab_name === '') {
            this.fieldJsonData.tab_list[index].tab_name_err = true
            this.isError = true
          }
          if (this.fieldJsonData.tab_list[index].content_heading === '') {
            this.fieldJsonData.tab_list[index].content_heading_err = true
            this.isError = true
          }
          if (this.fieldJsonData.tab_list[index].content_description === '') {
            this.fieldJsonData.tab_list[index].content_description_err = true
            this.isError = true
          }
          if (this.fieldJsonData.tab_list[index].img_url === '') {
            this.fieldJsonData.tab_list[index].img_url_err = true
            this.isError = true
          }
          if (this.fieldJsonData.tab_list[index].img_alt === '') {
            this.fieldJsonData.tab_list[index].img_alt_err = true
            this.isError = true
          }
          if (this.fieldJsonData.tab_list[index].cta_text === '') {
            this.fieldJsonData.tab_list[index].cta_text_err = true
            this.isError = true
          }
          if (this.fieldJsonData.tab_list[index].cta_url === null) {
            this.fieldJsonData.tab_list[index].cta_url_err = true
            this.isError = true
          }
      }
      // for (let indexM = 0; indexM < this.fieldJsonData.tab_list.length; indexM++) {
      //   for (let index = 0; index < this.fieldJsonData.tab_list[indexM].icons_list.length; index++) {
      //       if (this.fieldJsonData.tab_list[indexM].icons_list[index].image_url === '') {
      //         this.fieldJsonData.tab_list[indexM].icons_list[index].image_url_err = true
      //         this.isError = true
      //       }
      //       if (this.fieldJsonData.tab_list[indexM].icons_list[index].image_alt === '') {
      //         this.fieldJsonData.tab_list[indexM].icons_list[index].image_alt_err = true
      //         this.isError = true
      //       }
      //   }
      // }
  
      if (this.isError === false) {
        for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
            delete this.fieldJsonData.tab_list[index].content_heading_err
            delete this.fieldJsonData.tab_list[index].tab_name_err
            delete this.fieldJsonData.tab_list[index].content_description_err
            delete this.fieldJsonData.tab_list[index].img_url_err
            delete this.fieldJsonData.tab_list[index].img_alt_err
            delete this.fieldJsonData.tab_list[index].cta_text_err
            delete this.fieldJsonData.tab_list[index].cta_url_err
        }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>